<template>

    <div class="items-center flex-wrap flex" v-if="lgScreen && breadcrumbItems?.length">
      <u-button
        v-if="baseLocation"
        :to="baseLocation"
        variant="ghost"
        icon="i-ri-arrow-left-long-line"
        color="charcoal"
        size="xs"
        :title="baseBtnTooltip"
      />
      <span v-for="(item, index) in breadcrumbItems" class="flex items-center text-sm select-none font-semibold">
        <span v-if="index" class="font-bold"> / </span>

        <u-popover v-if="item.isDropdown" :popper="{ arrow: true }">
         <a class="text-charcoal mx-2 cursor-pointer no-underline hover:underline">...</a>

          <template #panel>
            <ul class="list-none p-2">
              <li
                v-for="(dropdownItem, dropdownItemIndex) in item.items"
                class="p-2 flex items-start hover:bg-shell cursor-pointer"
                @click="itemClick(dropdownItem)"
              >
                <u-icon
                  v-if="dropdownItemIndex"
                  name="i-ri-arrow-down-s-line"
                  class="rotate-45 mr-1 text-lg"
                  :style="{marginLeft: `${(Math.max(dropdownItemIndex - 1, 0)) * 10}px`}"
                />
                <div class="max-w-72 break-long-string">
                  <slot name="dropdown-item" :item="dropdownItem">
                    {{ dropdownItem[labelKey] }}
                  </slot>
                </div>
              </li>
            </ul>
          </template>
        </u-popover>

        <slot v-else :item="item">
           <a @click.prevent="itemClick(item)" class="text-charcoal mx-2 cursor-pointer no-underline hover:underline flex">
              <span class="max-w-36 min-[375px]:max-w-52 sm:max-w-80 ellipsis-overflow">{{item[labelKey]}}</span>
            </a>
        </slot>
      </span>
    </div>
    <div v-else-if="!lgScreen">
      <u-button-group size="sm">
        <u-button
          v-if="baseLocation"
          :to="baseLocation"
          variant="outline"
          icon="i-ri-arrow-left-long-line"
          color="charcoal"
          :title="baseBtnTooltip"
        />
        <u-button
          v-else-if="breadcrumbItems?.length"
          color="charcoal"
          variant="outline"
          icon="i-ri-corner-left-up-line"
          @click="itemClick(breadcrumbItems[breadcrumbItems.length - 1])"
          label="Parent"
        />
      </u-button-group>
    </div>

</template>

<script setup>

  const emit = defineEmits(['item-click']);
  const props = defineProps({
    items: Array,
    baseLocation: String,
    baseBtnTooltip: String,
    labelKey: {
      type: String,
      default: 'name',
    }
  });

  const {lg: lgScreen} = useScreenSize();

  const dropdownItems = computed(() => props.items?.length > 2 && props.items.slice(0, props.items.length - 1));

  const breadcrumbItems = computed(() => props.items && [
    dropdownItems.value
      ? {
        isDropdown: true,
        items: dropdownItems.value
      }
      : props.items[0],
    props.items.length > 1 && props.items[props.items.length - 1]
  ]
  .filter(Boolean));

  function itemClick(item) {
    emit('item-click', item);
  }

</script>
